import React from 'react'

export default function OuterInput(props) {
    return (
        <div className="outer-input-container">
            <div className="outer-input-icon">
                {props.children}
            </div>
            <input required className="outer-input-field" type={props.type} placeholder={props.placeholder} name={props.name_} onChange={props.onChange} value={props.value} />
        </div>
    )
}
